import { useState, useEffect } from "react";
import { G, D, D2, D3, D4, BR, T2, PILARES } from "../theme";
import { getMedia, getCl } from "../utils";
import Gauge from "./Gauge";
import Radar from "./Radar";
import { gerarPDF } from "./gerarPDF";

export default function DashAluno(props) {
  var aluno = props.aluno;
  var scores = aluno.scores_json || aluno.scores;
  var med = getMedia(scores), cl = getCl(med);
  var sorted = PILARES.slice().sort(function(a,b){ return scores[a.key]-scores[b.key]; });
  var top3 = sorted.slice(0,3);
  var data = aluno.created_at ? new Date(aluno.created_at).toLocaleDateString("pt-BR") : aluno.criadoEm;
  var alunoNome = aluno.aluno_nome || aluno.alunoNome || "";
  var [mobile, setMobile] = useState(window.innerWidth < 768);

  useEffect(function() {
    function onResize() { setMobile(window.innerWidth < 768); }
    window.addEventListener("resize", onResize);
    return function() { window.removeEventListener("resize", onResize); };
  }, []);

  var historico = (props.minhasRespostas || [])
    .filter(function(r){ return (r.aluno_nome || "").toLowerCase() === alunoNome.toLowerCase(); })
    .sort(function(a,b){ return new Date(a.created_at) - new Date(b.created_at); });

  return (
    <div style={{flex:1,overflowY:"auto",background:"#0F0F0F"}}>
      <div style={{background:D2,borderBottom:"1px solid "+BR,padding:mobile?"0.75rem 1rem":"1rem 2rem",
        display:"flex",flexDirection:mobile?"column":"row",justifyContent:"space-between",alignItems:mobile?"flex-start":"center",gap:10}}>
        <div>
          <div style={{fontSize:11,color:T2,marginBottom:2}}>Aluno avaliado</div>
          <div style={{fontSize:mobile?18:22,fontWeight:700,color:"#fff"}}>{alunoNome}</div>
        </div>
        <div style={{display:"flex",gap:8,alignItems:"center",flexWrap:"wrap"}}>
          <div style={{fontSize:12,color:T2}}>📅 {data}</div>
          <button onClick={function(){ gerarPDF(aluno, props.coachNome, props.minhasRespostas); }}
            style={{background:G,color:D,border:"none",borderRadius:9,padding:"9px 14px",fontWeight:700,fontSize:12,cursor:"pointer"}}>
            📄 Exportar
          </button>
          <button onClick={props.onVoltar}
            style={{background:"none",border:"1px solid "+BR,borderRadius:9,padding:"9px 14px",color:T2,fontSize:12,cursor:"pointer"}}>
            ← Voltar
          </button>
        </div>
      </div>

      <div style={{padding:mobile?"1rem":"1.5rem 2rem"}}>
        <div style={{background:D,border:"1px solid "+BR,borderRadius:16,padding:mobile?"1.25rem":"1.75rem",marginBottom:20,
          display:"flex",flexDirection:mobile?"column":"row",justifyContent:"space-between",alignItems:mobile?"flex-start":"center",gap:16}}>
          <div style={{flex:1}}>
            <div style={{fontSize:11,color:T2,letterSpacing:2,marginBottom:8}}>ESTADO GERAL DO SISTEMA</div>
            <div style={{fontSize:mobile?20:26,fontWeight:700,color:cl.cor,marginBottom:8}}>{cl.label.toUpperCase()}</div>
            <div style={{fontSize:13,color:T2,lineHeight:1.6}}>
              {med>=7 ? "Bom desempenho. Pequenos ajustes podem elevar ainda mais os resultados." : med>=5 ? "Desequilíbrios moderados afetando os resultados." : "Desequilíbrios importantes limitando o progresso."}
            </div>
          </div>
          <div style={{display:"flex",alignItems:"center",gap:16,flexShrink:0}}>
            <Gauge value={med}/>
            <div style={{background:D3,border:"1px solid "+BR,borderRadius:14,padding:"1rem 1.25rem",textAlign:"center"}}>
              <div style={{fontSize:11,color:T2,marginBottom:4}}>PONTUAÇÃO</div>
              <div style={{fontSize:32,fontWeight:700,color:cl.cor}}>{med}</div>
              <div style={{fontSize:12,color:T2,marginBottom:8}}>/10</div>
              <span style={{fontSize:11,padding:"4px 12px",borderRadius:20,background:cl.bg,color:cl.cor,fontWeight:600}}>{cl.label}</span>
            </div>
          </div>
        </div>

        {historico.length >= 2 && (
          <div style={{background:D3,border:"1px solid "+BR,borderRadius:14,padding:"1.25rem",marginBottom:20}}>
            <div style={{fontSize:13,fontWeight:600,color:"#fff",marginBottom:4}}>📈 Evolução do aluno</div>
            <div style={{fontSize:11,color:T2,marginBottom:16}}>{historico.length} avaliações registadas</div>
            {(function(){
              var W = mobile ? 300 : 520, H = 160;
              var padL = 36, padR = 16, padT = 16, padB = 36;
              var chartW = W - padL - padR;
              var chartH = H - padT - padB;
              var minV = 0, maxV = 10;
              var n = historico.length;

              function xPos(i) { return padL + (i / (n-1)) * chartW; }
              function yPos(v) { return padT + (1 - (v - minV) / (maxV - minV)) * chartH; }

              // Grid lines
              var gridLines = [2,4,6,8,10].map(function(v) {
                var y = yPos(v);
                return (
                  <g key={v}>
                    <line x1={padL} y1={y} x2={W-padR} y2={y} stroke={BR} strokeWidth="1" strokeDasharray="3,3"/>
                    <text x={padL-6} y={y+4} textAnchor="end" fontSize="9" fill={T2}>{v}</text>
                  </g>
                );
              });

              // Line path
              var points = historico.map(function(h, i){ return xPos(i)+","+yPos(h.media_geral); });
              var linePath = "M " + points.join(" L ");

              // Area fill
              var areaPath = "M "+padL+","+(padT+chartH)+" L "+linePath.slice(2)+" L "+(W-padR)+","+(padT+chartH)+" Z";

              // Dots and labels
              var dots = historico.map(function(h, i){
                var cx = xPos(i), cy = yPos(h.media_geral);
                var hcl = getCl(h.media_geral);
                var hdata = h.created_at ? new Date(h.created_at).toLocaleDateString("pt-BR",{day:"2-digit",month:"2-digit"}) : "";
                return (
                  <g key={i}>
                    <circle cx={cx} cy={cy} r="5" fill={hcl.cor} stroke={D3} strokeWidth="2"/>
                    <text x={cx} y={cy-10} textAnchor="middle" fontSize="10" fontWeight="700" fill={hcl.cor}>{h.media_geral}</text>
                    <text x={cx} y={H-padB+14} textAnchor="middle" fontSize="9" fill={T2}>{hdata}</text>
                  </g>
                );
              });

              // Diff badge
              var primeiro = historico[0].media_geral;
              var ultimo = historico[historico.length-1].media_geral;
              var diff = Math.round((ultimo - primeiro) * 10) / 10;
              var diffCor = diff > 0 ? "#4CAF50" : diff < 0 ? "#E53935" : T2;
              var diffSeta = diff > 0 ? "↑" : diff < 0 ? "↓" : "→";

              return (
                <div>
                  <div style={{display:"flex",gap:16,marginBottom:12,flexWrap:"wrap"}}>
                    <div style={{background:D4,borderRadius:8,padding:"8px 14px",fontSize:12}}>
                      <span style={{color:T2}}>Início: </span>
                      <span style={{fontWeight:700,color:getCl(primeiro).cor}}>{primeiro}/10</span>
                    </div>
                    <div style={{background:D4,borderRadius:8,padding:"8px 14px",fontSize:12}}>
                      <span style={{color:T2}}>Atual: </span>
                      <span style={{fontWeight:700,color:getCl(ultimo).cor}}>{ultimo}/10</span>
                    </div>
                    <div style={{background:D4,borderRadius:8,padding:"8px 14px",fontSize:12}}>
                      <span style={{color:T2}}>Variação: </span>
                      <span style={{fontWeight:700,color:diffCor}}>{diffSeta} {Math.abs(diff)} pts</span>
                    </div>
                  </div>
                  <div style={{overflowX:"auto"}}>
                    <svg viewBox={"0 0 "+W+" "+H} width="100%" style={{minWidth:280,display:"block"}}>
                      {gridLines}
                      <path d={areaPath} fill={G+"18"}/>
                      <path d={linePath} fill="none" stroke={G} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
                      {dots}
                    </svg>
                  </div>
                </div>
              );
            })()}
          </div>
        )}

        <div style={{display:"grid",gridTemplateColumns:mobile?"1fr 1fr":"repeat(3,1fr)",gap:12,marginBottom:20}}>
          {PILARES.map(function(p) {
            var sc = scores[p.key], c = getCl(sc);
            return (
              <div key={p.key} style={{background:D3,border:"1px solid "+BR,borderRadius:14,padding:"1rem"}}>
                <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:10}}>
                  <div>
                    <div style={{fontSize:20,marginBottom:4}}>{p.icon}</div>
                    <div style={{fontSize:10,color:T2,letterSpacing:1,fontWeight:500}}>{p.label.toUpperCase()}</div>
                  </div>
                  <span style={{fontSize:10,padding:"3px 8px",borderRadius:20,background:c.bg,color:c.cor,fontWeight:600}}>{c.label}</span>
                </div>
                <div style={{fontSize:24,fontWeight:700,color:c.cor,marginBottom:8}}>
                  {sc}<span style={{fontSize:13,color:T2,fontWeight:400}}>/10</span>
                </div>
                <div style={{background:D4,borderRadius:4,height:5}}>
                  <div style={{background:c.cor,height:5,borderRadius:4,width:(sc*10)+"%"}}/>
                </div>
              </div>
            );
          })}
        </div>

        <div style={{display:"grid",gridTemplateColumns:mobile?"1fr":"1fr 1fr",gap:16}}>
          <div style={{background:D3,border:"1px solid "+BR,borderRadius:14,padding:"1.25rem"}}>
            <div style={{fontSize:13,fontWeight:600,color:"#fff",marginBottom:14}}>⚠️ PRIORIDADE DE INTERVENÇÃO</div>
            {top3.map(function(p, i) {
              var c = getCl(scores[p.key]);
              return (
                <div key={p.key} style={{display:"flex",alignItems:"center",gap:12,background:D4,borderRadius:10,padding:"12px 14px",marginBottom:8}}>
                  <div style={{width:24,height:24,borderRadius:"50%",background:c.cor,display:"flex",alignItems:"center",justifyContent:"center",fontSize:11,fontWeight:700,color:"#000",flexShrink:0}}>{i+1}</div>
                  <span style={{fontSize:18}}>{p.icon}</span>
                  <div style={{flex:1}}>
                    <div style={{fontWeight:600,fontSize:13,color:"#fff"}}>{p.label}</div>
                    <div style={{fontSize:11,color:T2}}>{scores[p.key]}/10</div>
                  </div>
                  <span style={{fontSize:10,padding:"3px 8px",borderRadius:20,background:c.bg,color:c.cor,fontWeight:600}}>{c.label}</span>
                </div>
              );
            })}
          </div>
          <div style={{background:D3,border:"1px solid "+BR,borderRadius:14,padding:"1.25rem",display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center"}}>
            <div style={{fontSize:13,fontWeight:600,color:"#fff",marginBottom:4,alignSelf:"flex-start"}}>VISÃO RADAR</div>
            <Radar scores={scores}/>
          </div>
        </div>
      </div>
    </div>
  );
}
